import styled from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'
import { Price as PriceType } from 'shop/types/cart'
import { BasePrice } from 'shop/types/common'
import { formatMoney } from 'shop/utils/common'

type Orientation = 'vertical' | 'horizontal'
interface Props {
  price: PriceType | BasePrice
  type?: Orientation
}

const Price = ({ price, type = 'vertical' }: Props): JSX.Element => {
  const { base: basePrice, discounted: discountedPrice = null } =
    price as PriceType
  /** Check if basePrice & discountedPrice are equal in case of subtotal discountedPrice is provided when a delivery discount is applied */
  const showDiscount = !!(
    discountedPrice &&
    basePrice &&
    basePrice !== discountedPrice
  )

  return (
    <Content data-testid='item-price' showDiscount={showDiscount} type={type}>
      <Amount type={type} showDiscount={showDiscount}>
        {formatMoney(basePrice)}
      </Amount>
      {showDiscount && (
        <Amount type={type} showDiscount={showDiscount} discountedPrice>
          {formatMoney(discountedPrice)}
        </Amount>
      )}
    </Content>
  )
}

const Content = styled.div<
  StyledHTMLElement & { type: Orientation; showDiscount: boolean }
>(({ type, showDiscount }) => ({
  justifySelf: 'end',
  display: 'flex',
  // Reverse order only in vertical layout
  flexDirection: type === 'horizontal' ? 'row-reverse' : 'column-reverse',
  gap: type === 'horizontal' && showDiscount ? '12px' : '2px',
  alignItems: 'center',
  position: 'relative'
}))

const Amount = styled.p<
  StyledHTMLElement & {
    discountedPrice?: boolean
    showDiscount: boolean
    type: Orientation
  }
>(({ discountedPrice, showDiscount, type }) => {
  const isOriginalPrice = !discountedPrice && showDiscount
  const isHorizontal = type === 'horizontal'

  return {
    color: discountedPrice ? '#389E0D' : showDiscount ? '#59595A' : '#2A2A2A',
    margin: 0,
    position: isOriginalPrice && !isHorizontal ? 'absolute' : 'static',
    top: isOriginalPrice && !isHorizontal ? '20px' : 'auto',
    textDecoration: isOriginalPrice ? 'line-through' : 'none',
    fontWeight: isOriginalPrice ? 400 : 'inherit',
    fontSize: isOriginalPrice && !isHorizontal ? '12px' : '16px'
  }
})

export default Price
